import {NavigationActions} from "react-navigation";


export const LoginAction = NavigationActions.navigate({
  routeName: 'App',
  params: {isAuth: true},

});


export const LogoutAction = NavigationActions.navigate({
  routeName: 'Login',
  params: {isAuth: false},

});
